<template>
  <div>
    <echarts-menu v-if="role !== '27'" :dataMenu="dataMenu" @changeydata="onchangeData"></echarts-menu>
    <echarts-menu v-if="role === '27'" :dataMenu="dataMerchantsMenu" @changeydata="onchangeData"></echarts-menu>
    <text-echarts v-if="showChartOrList" :data="showData" class="echarts"></text-echarts>
    <home-table v-else></home-table>
  </div>
</template>
<script>
import echartsMenu from "./echarts-menu.vue";
import textEcharts from "./text-echarts.vue";
import homeTable from "./homeTable.vue";
import { mainInfo } from "@/api/homeApi.js";
export default {
  data() {
    return {
      date: {
        endDate: "",
        startDate: "",
      },
      showChartOrList: true,
      dataMenu: {
        orderNumData: {
          name: "下单数量（最近15日）",
          val: "orderNumData",
          index: 1,
        },
        orderMoneyData: {
          name: "下单金额（最近15日）",
          val: "orderMoneyData",
          index: 2,
        },
        countNewUserNum: {
          name: "日新增会员（最近15日）",
          val: "countNewUserNum",
          index: 3,
        },
        accountChartLoginMonthData: {
          name: "用户活跃度（最近15日）",
          val: "accountChartLoginMonthData",
          index: 4,
        },
        hydbb: {
          name: "活跃度报表（最近15日）",
          val: "hydbb",
          index: 5,
        },
      },
      dataMerchantsMenu: {
        orderNumData: {
          name: "下单数量（最近15日）",
          val: "orderNumData",
          index: 1,
        },
        orderMoneyData: {
          name: "下单金额（最近15日）",
          val: "orderMoneyData",
          index: 2,
        },
      },
      showData: [],
      Ydata: {
        orderNumData: [],
        orderMoneyData: [],
        countNewUserNum: [],
        accountChartLoginMonthData: [],
        hydbb: [],
      },
      role: sessionStorage.getItem("role"),
    };
  },
  components: {
    echartsMenu,
    textEcharts,
    homeTable,
  },
  mounted() {
    this.getMainInfo();
    // this.showData = this.Ydata.orderNumData
  },
  methods: {
    onchangeData(val) {
      this.showData = this.Ydata[val.val];
      console.log('this.showData', this.showData)
      if (val.val === "hydbb") {
        // false为显示报表，true显示图表
        this.showChartOrList = false;
      } else {
        this.showChartOrList = true;
      }
    },
    getMainInfo() {
      mainInfo(this.date).then((res) => {
        this.showData = JSON.parse(res.data.orderNumData)
        this.Ydata.orderNumData = JSON.parse(res.data.orderNumData)
        this.Ydata.orderMoneyData = JSON.parse(res.data.orderMoneyData)
        this.Ydata.countNewUserNum = JSON.parse(res.data.countNewUserNum)
        this.Ydata.accountChartLoginMonthData = JSON.parse(res.data.accountChartLoginMonthData)
        console.log(' this.Ydata------------------------',this.Ydata);
      });
    },
  },
};
</script>
<style>
.echarts {
  /* width: 1115px; */
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/homeEchatrs.vue